module.exports = __webpack_public_path__ + "img/bb.1db266d7.svg";